<template>
  <form class="login-form" @submit.prevent="newPassword">
    <div class="card mb-0">
      <div class="card-body">
        <div class="text-center mb-3">
          <img
            src="@/assets/img/logos/logo_mini.png"
            class="h-72px"
            alt="Logo"
          />
          <h5 class="mt-1 mb-0">Portal de Relatórios</h5>
          <span class="text-muted">Crie sua nova senha</span>
        </div>
        <div class="mb-3">
          <div class="form-control-feedback form-control-feedback-start">
            <input
              type="password"
              class="form-control"
              :class="{ 'is-invalid': v$.senha.$errors.length }"
              placeholder="Senha"
              v-model="v$.senha.$model"
            />
            <div class="form-control-feedback-icon">
              <i class="ph ph-lock text-muted" />
            </div>
            <span
              v-if="
                (v$.senha.required.$invalid || v$.senha.minLength.$invalid) &&
                v$.senha.$errors.length
              "
              class="invalid-feedback"
            >
              A senha deve ter pelo menos
              {{ v$.senha.minLength.$params.min }} caracteres
            </span>
          </div>
        </div>
        <div class="mb-3">
          <div class="form-control-feedback form-control-feedback-start">
            <input
              type="password"
              class="form-control"
              :class="{
                'is-invalid': v$.confirmaSenha.$errors.length,
              }"
              placeholder="Confirme a Senha"
              v-model="v$.confirmaSenha.$model"
            />
            <div class="form-control-feedback-icon">
              <i class="ph ph-lock text-muted" />
            </div>
            <span
              v-if="
                v$.confirmaSenha.sameAsPassword.$invalid &&
                v$.confirmaSenha.$errors.length
              "
              class="invalid-feedback"
            >
              As senhas devem ser idênticas
            </span>
          </div>
        </div>
        <div class="mb-3">
          <button
            type="submit"
            class="btn btn-dark w-100"
            title="Criar Nova Senha"
            :disabled="v$.$invalid || disableButton"
          >
            <span v-if="disableButton">
              <i class="ph ph-spinner spinner" />
            </span>
            <span v-else>Criar Nova Senha</span>
          </button>
        </div>
        <div class="text-center" title="Login">
          <router-link to="/">Login</router-link>
        </div>
      </div>
    </div>
  </form>
</template>

<script>
import { useVuelidate } from '@vuelidate/core'
import { required, minLength, sameAs } from '@vuelidate/validators'
import PATHS from '@/router/routesMap'

export default {
  name: 'NewPassword',

  setup() {
    return { v$: useVuelidate() }
  },

  data() {
    return {
      key: this.$route.params.key,
      senha: '',
      confirmaSenha: '',
      disableButton: false,
    }
  },

  methods: {
    async newPassword() {
      if (!this.v$.$invalid) {
        this.disableButton = true
        try {
          const response = await this.$store.dispatch('newPassword', {
            key: this.key,
            senha: this.senha,
            confirmaSenha: this.confirmaSenha,
          })

          this.resetForm()

          if (response && response.message) {
            this.$root.$refs.notification.success(response.message)
            this.$router.push(PATHS.SIGN_IN)
          } else {
            this.$root.$refs.notification.error(
              'Não foi possível se conectar ao servidor.',
            )
          }
        } catch (error) {
          this.resetForm()

          if (error && error.message) {
            this.$root.$refs.notification.warning(error.message)
          } else {
            this.$root.$refs.notification.error(
              'Não foi possível se conectar ao servidor.',
            )
          }
        }
      }
    },

    resetForm() {
      this.disableButton = false
      this.key = ''
      this.senha = ''
      this.confirmaSenha = ''
      this.v$.$reset()
    },
  },

  validations() {
    return {
      senha: {
        required,
        minLength: minLength(6),
      },
      confirmaSenha: {
        sameAsPassword: sameAs(this.senha),
      },
    }
  },
}
</script>
